import { render, staticRenderFns } from "./MainReportSidebar.vue?vue&type=template&id=6ab99a34"
import script from "./MainReportSidebar.vue?vue&type=script&lang=js"
export * from "./MainReportSidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports